<template>
  <section class="vbox">
    <section class="scrollable wrapper">
      <section class="hbox stretch">
        <div class="content-header">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>营销</el-breadcrumb-item>
            <el-breadcrumb-item>红包管理</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="content-main">
          <el-form :inline="true" size="medium">            
            <el-form-item>
              <el-button type="primary" class="el-icon-circle-plus-outline" v-on:click="AddIndustry" size="small" >新增</el-button>
            </el-form-item>
            <el-form-item >
              <el-input  placeholder="行业名称" v-model="queryParam.title" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item >
              <el-select v-model="queryParam.state" size="small" placeholder="请选择状态" clearable>
                <el-option label="请选择" value=""></el-option>
                <el-option label="未发布" value="0"></el-option>
                <el-option label="已发布" value="1"></el-option>
                <el-option label="已领完" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" v-on:click="Search" size="small" >查询</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="items" style="width: 100%" >
            <el-table-column  prop="Title"  label="名称"> </el-table-column>            
            <el-table-column  prop="TotalAmount" label="总金额"> </el-table-column>
            <el-table-column  prop="TotalCount" label="总数量"> </el-table-column>
            <el-table-column  prop="ReceiveCount" label="领取数量"> </el-table-column>
            <el-table-column  prop="CreateTime" label="创建时间"> </el-table-column>
            <el-table-column  prop="OpenTime" label="可领时间"> </el-table-column>
            <el-table-column  prop="State"  label="状态" > 
              <template slot-scope="scope">                    
                <p v-if="scope.row.State==0">未发布</p>
                <p v-if="scope.row.State==1">已发布</p>
                <p v-if="scope.row.State==2">已领完</p>
              </template>
            </el-table-column>
            <el-table-column  fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click.native.prevent="editIndustry(scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="deleteRow(scope.row)" type="text" size="small"> 删除</el-button>
              <el-button @click="Publish(scope.row)" type="text" size="small"> 发布</el-button>          
            </template>
          </el-table-column>
          </el-table>
          <el-pagination
            :hide-on-single-page="true"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryParam.pageIndex"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="queryParam.pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="queryParam.totalCount">
          </el-pagination>
        </div>
      </section>
    </section>
    <dia v-bind:dialog="dialog" @GetData="GetData"></dia>
  </section>
</template>
<script  type='text/ecmascript-6'>
  import dia from './info'
  export default {
    props:{
    },
    data (){
      return {        
        items:[],
        dialog: {
          id:'0',
          title: '',
          isShow:false
        },
        queryParam:{
          title:'',
          pageIndex:1,
          pagesize:10,
          totalCount:10,
          sort:' CreateTime desc ',
          state:''
        }
      }
    },
    computed:{
    },
    mounted(){
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.queryParam.pageIndex = 1;
        this.GetData();
      },
      AddIndustry:function(){
        this.dialog.id = ''
        this.dialog.title = '新增红包'
        this.dialog.isShow = true
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/RedEnvelope/Index',
          params:that.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.items = resp.data.items
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      deleteRow(row) {        
        this.$confirm('确定要删除该红包吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var that = this
          this.axios({
            method:'get',
            url:that.global.serverSrc + '/api/RedEnvelope/Delete',
            params:{
              id: row.Id
            }
          }).then(function (resp) {  
            if(resp.data.errorCode==0){              
              that.$message.success(resp.data.message);
              that.GetData();
            }else {              
              that.$message.warning(resp.data.message);
            }
          }).catch(resp => {
            console.log('请求失败：' + resp.message + ',' + resp.stack)
          })
        }).catch(() => {
            
        });
      },
      Publish:function(row){
        this.$confirm('确定要发布该红包吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var that = this
          this.axios({
            method:'get',
            url:that.global.serverSrc + '/api/RedEnvelope/Publish',
            params:{
              id: row.Id
            }
          }).then(function (resp) {  
            if(resp.data.errorCode==0){              
              that.$message.success(resp.data.message);
              that.GetData();
            }else {              
              that.$message.warning(resp.data.message);
            }
          }).catch(resp => {
            console.log('请求失败：' + resp.message + ',' + resp.stack)
          })
        }).catch(() => {
            
        });
      },
      editIndustry:function(row){
        this.dialog.id = row.Id
        this.dialog.title = '修改红包'
        this.dialog.isShow = true 
      },
      handleSizeChange(val) {
        this.queryParam.pagesize = val
        this.queryParam.pageIndex = 1
        this.GetData()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val
        this.GetData()
      }
    },
    components:{     
      dia
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>